import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import {
    ChangeDetectionStrategy,
    Component,
    ContentChild,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    TemplateRef,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';

import { Subject } from 'rxjs';
import {
    distinctUntilChanged,
    filter,
    map,
    takeUntil,
    tap,
} from 'rxjs/operators';

export interface LiveFeedEvent {
    id: number;
}

@Component({
    selector: 'ui-live-feed',
    templateUrl: './ui-live-feed.component.html',
    styleUrls: ['./ui-live-feed.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiLiveFeedComponent implements OnInit, OnDestroy {

    @Input()
    public events!: LiveFeedEvent[];

    @Input()
    public hasMoreData = false;

    @Input()
    public loadingMoreData = false;

    @Output()
    public requestMoreData = new EventEmitter();

    @ContentChild(TemplateRef, { static: true })
    public contentTemplate!: TemplateRef<LiveFeedEvent>;

    @ViewChild(CdkVirtualScrollViewport, { static: true })
    private _virtualScroller!: CdkVirtualScrollViewport;
    private _destroyed$ = new Subject();

    public trackById(_: number, entity: LiveFeedEvent) {
        return entity.id;
    }

    ngOnInit() {
        this._virtualScroller.renderedRangeStream.pipe(
            map(({ end }) => end),
            filter(end => this.hasMoreData && !this.loadingMoreData && (this.events.length - 1) <= end),
            distinctUntilChanged(),
            tap(_ => this.requestMoreData.emit()),
            takeUntil(this._destroyed$),
        ).subscribe();
    }

    ngOnDestroy() {
        this._destroyed$.next();
        this._destroyed$.complete();
    }

    public scrollToTop() {
        if (!this._virtualScroller) { return; }

        this._virtualScroller.scrollToIndex(0);
    }
}
